import { useEffect, useState } from 'react';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { HR } from 'foundations-components/transitional/components/HR';
import { logRavenException } from '../../_core/utils/errors';
import { getUpgradePointPromise } from '../utils';
import ValuePropModalHeader from './ValuePropModalHeader';
import ValuePropModalBody from './ValuePropModalBody';
import ValuePropModalFooter from './ValuePropModalFooter';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ValuePropModalContent = ({
  config,
  onClose
}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [upgradeConfig, setUpgradeConfig] = useState(undefined);
  useEffect(() => {
    getUpgradePointPromise({
      upgradeKey: config.upgradeKey
    }).then(result => {
      if (result) {
        setUpgradeConfig(result);
      }
    }).catch(error => {
      logRavenException({
        customMessage: 'ValuePropModalContent: Failed to fetch upgrade config',
        error,
        uniqueId: config.upgradeKey
      });
    });
  }, [config.upgradeKey]);
  return /*#__PURE__*/_jsxs(Modal, {
    use: "conversational",
    width: 900,
    size: "auto",
    onEsc: onClose,
    children: [/*#__PURE__*/_jsx(ValuePropModalHeader, {
      config: config,
      onClose: onClose
    }), /*#__PURE__*/_jsx(HR, {
      distance: "flush"
    }), /*#__PURE__*/_jsx(ValuePropModalBody, {
      config: config,
      activeIndex: activeIndex,
      onActiveIndexChange: setActiveIndex
    }), /*#__PURE__*/_jsx(HR, {
      distance: "flush"
    }), upgradeConfig && /*#__PURE__*/_jsx(DialogFooter, {
      align: "left",
      children: /*#__PURE__*/_jsx(ValuePropModalFooter, {
        upgradeConfig: upgradeConfig
      })
    })]
  });
};
export default ValuePropModalContent;